import type { Template } from "@/types";

export const PO_02_H0_V2: Template[] = [

    {
        id: "po-02-h0v2-01",
        name: "PO 01 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 649, height: 827, rotation: 0, imageRotation: 0 },
            { id: "2", x: 731, y: 71, width: 486, height: 685, rotation: 0, imageRotation: 0 }
        ],
    },


    {
        id: "po-02-h0v2-02",
        name: "PO 02 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 82, y: 71, width: 486, height: 685, rotation: 0, imageRotation: 0 },
            { id: "2", x: 649, y: 0, width: 649, height: 827, rotation: 0, imageRotation: 0 }
        ],
    },


    {
        id: "po-02-h0v2-03",
        name: "PO 03 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_03.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 728, y: 77, width: 460, height: 659, rotation: 0, imageRotation: 0 },
            { id: "2", x: 89, y: 77, width: 460, height: 659, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-04",
        name: "PO 04 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_04.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 235, y: 121, width: 399, height: 573, rotation: 0, imageRotation: 0 },
            { id: "2", x: 645, y: 121, width: 399, height: 573, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-05",
        name: "PO 05 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_05.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 36, y: 0, width: 567, height: 814, rotation: 0, imageRotation: 0 },
            { id: "2", x: 676, y: 0, width: 567, height: 814, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-06",
        name: "PO 06 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_06.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 36, y: 0, width: 567, height: 814, rotation: 0, imageRotation: 0 },
            { id: "2", x: 790, y: 162, width: 340, height: 488, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-07",
        name: "PO 07 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_07.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 77, y: 58, width: 486, height: 699, rotation: 0, imageRotation: 0 },
            { id: "2", x: 790, y: 162, width: 340, height: 488, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-08",
        name: "PO 08 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_08.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 121, y: 121, width: 399, height: 573, rotation: 0, imageRotation: 0 },
            { id: "2", x: 760, y: 121, width: 399, height: 573, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-09",
        name: "PO 09 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_09.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 676, y: 0, width: 567, height: 814, rotation: 0, imageRotation: 0 },
            { id: "2", x: 150, y: 162, width: 340, height: 488, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-10",
        name: "PO 10 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_10.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 717, y: 58, width: 486, height: 699, rotation: 0, imageRotation: 0 },
            { id: "2", x: 150, y: 162, width: 340, height: 488, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-11",
        name: "PO 11 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_11.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 103, y: 96, width: 434, height: 622, rotation: 0, imageRotation: 0 },
            { id: "2", x: 743, y: 96, width: 434, height: 622, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-02-h0v2-12",
        name: "PO 12 - H0V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-02-h0_v2_12.png",
        size: [1279, 814],
        style: {},
        slots: [
            { id: "1", x: 36, y: 32, width: 568, height: 751, rotation: 0, imageRotation: 0 },
            { id: "2", x: 675, y: 32, width: 568, height: 751, rotation: 0, imageRotation: 0 }
        ],
    }
];